import { magnifyingGlassEffect } from "../utils/magnifying_glass";

const observerOptions = {
  rootMargin: "-80px",
};

if (
  document.querySelector(".v_deploy") ||
  document.querySelector(".v_experts")
) {
  magnifyingGlassEffect(observerOptions);
}
